module.exports = __webpack_public_path__ + "img/info-left.338836b9.jpg";